import * as ActionTypes from '../../actions/allActions'
import { normalizeResidence } from "../../normalizers/residenceNormalizer"

const newResidenceInit = { type: 'house', hasPets: false, surface: '', streetName: '', streetNumber: '', city: '', zipCode: '', otherInfo: '', howToGetIn: '' }
const initialState = { residences: [], newResidence: newResidenceInit, residenceToDeleteID: null }
const residences = (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.FETCH_RESIDENCES_SUCCESS:
			return { ...state, residences: action.data.data.map(residence => normalizeResidence(residence)) }
		case ActionTypes.UPDATE_NEW_RESIDENCE:
			return { ...state, newResidence: { ...state.newResidence, ...action.changes } }
		case ActionTypes.CLEAR_NEW_RESIDENCE:
			return { ...state, newResidence: newResidenceInit }
		case ActionTypes.SELECT_RESIDENCE_FOR_ACTION:
			return { ...state, residenceToDeleteID: action.id}
		case ActionTypes.LOGOUT:
			return initialState
		default:
			return state
	}
}

export default residences


// WEBPACK FOOTER //
// ./src/reducers/data/residences.js